import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);

const hiddenButton2 = document.querySelector('.js-hidden-button-2');
const targetButton2 = document.querySelector('.js-button-2');
const hiddenButton = document.querySelector('.js-hero-hidden-button');
const targetButton = document.querySelector('.js-hero-button');

hiddenButton?.addEventListener('mouseenter', () => {
  targetButton.classList.add('active');
});

hiddenButton?.addEventListener('mouseleave', () => {
  targetButton.classList.remove('active');
});

hiddenButton2?.addEventListener('mouseenter', () => {
  targetButton2.classList.add('active');
});

hiddenButton2?.addEventListener('mouseleave', () => {
  targetButton2.classList.remove('active');
});

const videoWrap = document.querySelector('.hero__video');

if(videoWrap) {
  const video = videoWrap.querySelector('video');

  if (video) {
    const playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          videoWrap.classList.add('is-ready');
        })
        .catch(() => {
          video.remove();
        });
    }
  }
}

// const pinTitleMains = document.querySelectorAll('.hero__block');

// pinTitleMains.forEach((pinTitleMain) => {
//   ScrollTrigger.create({
//     trigger: pinTitleMain,
//     start: "top top",
//     toggleActions: "play none none none",
//     scrub: false,
//     onUpdate: (self) => {
//       const progress = self.progress;
//       const y = -200 * progress;
//       gsap.to(pinTitleMain, {
//         y: y,
//         ease: 'none',
//         overwrite: 'auto',
//         duration: 0.1,
//       });
//     },
//   });
// });
